// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "bundle." + chunkId + "." + "5771194c6733d9aa6f8d1be81562b8eb" + ".js";
};